// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./en_GB.json": { enumerable: true, get() { return import("/home/runner/work/employee-app/employee-app/common/translations/en_GB.json"); } },
  "./es_ES.json": { enumerable: true, get() { return import("/home/runner/work/employee-app/employee-app/common/translations/es_ES.json"); } },
  "./it_IT.json": { enumerable: true, get() { return import("/home/runner/work/employee-app/employee-app/common/translations/it_IT.json"); } },
  "./pt_PT.json": { enumerable: true, get() { return import("/home/runner/work/employee-app/employee-app/common/translations/pt_PT.json"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;